module.exports = __webpack_public_path__ + "static/img/2_13_1.6b7ce048.jpg";